export function validatePhone(phone) {
  if (phone) {
    const phoneCode = [
      "050",
      "051",
      "052",
      "053",
      "054",
      "055",
      "056",
      "058",
      "059",
    ];
    const areaCodes = ["02", "03", "04", "08", "09"];
    const value = phone.replace(/[^0-9]/g, "");
    if (value) {
      const correctAreaCode = areaCodes.filter(
        (n) => value.substr(0, n.length) === n && value.length === 9
      )[0];
      const correctPhoneCodes = phoneCode.filter(
        (n) => value.substr(0, n.length) === n && value.length === 10
      )[0];
      if (correctPhoneCodes || correctAreaCode) {
        return true;
      }
    }
  }
}
